module.exports = __webpack_public_path__ + "static/PR-1b57271e9fb30bf85941f94a3f4d7551.jpg";